fragment CertificateFragment on Certificate {
    id
    name
    bsci
    sa8000
}